import { Breadcrumb } from "antd";
import { useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router";
import { checkPermissionAction } from "../../../Reusable/Store/Action/AuthPermissionsAction";
import commonCssStyle from "../../UI/CommonCss.module.css";
import PermissionMessage from "../../UI/PermissionMessage";
function BreadcrumbForClient(props) {
  const navigate = useNavigate();
  const [openPMModal, setOpenPMModal] = useState({
    open: false,
    permission: "",
  });
  const array = ["Home", "Client", `Client details`];
  return (
    <>
      <Breadcrumb>
        {props.slide &&
          props.slide.map((data, index) => {
            return (
              <Breadcrumb.Item key={index}>
                <p
                  onClick={() => {
                    if (data === 1) {
                      props.getCheckPermissionHandler(
                        "dashboard",
                        (success) => {
                          if (success) {
                            navigate("/dashboard");
                          } else {
                            setOpenPMModal({
                              open: true,
                              permission: "Dashboard",
                            });
                          }
                        }
                      );
                    } else if (data === 2) {
                      props.permissions &&
                      props.permissions.find(
                        (data) =>
                          data === "client-list" ||
                          data === "client-delete" ||
                          data === "client-add" ||
                          data === "client-detail" ||
                          data === "client-edit" ||
                          data === "client-job" ||
                          data === "client-contact-info" ||
                          // data === "client-contact-person-info" ||
                          data === "client-billing-detail"
                      )
                        ? navigate("/clientCompany")
                        : setOpenPMModal({
                            open: true,
                            permission: "Client",
                          });
                    }
                  }}
                  className={` ${commonCssStyle.breadcrumbText} ${commonCssStyle.coursorPointer} ${commonCssStyle.marginBottomRemove}`}
                >
                  {array[index]}
                </p>
              </Breadcrumb.Item>
            );
          })}
      </Breadcrumb>
      <PermissionMessage
        onOpenPMModal={openPMModal}
        onClosePMModal={() => {
          setOpenPMModal({ open: false, permission: "" });
          props.setIsHavepermissionsHandler(false);
        }}
      />
    </>
  );
}
const mapStateToProps = (state) => {
  return {
    permissions: state.authpermissions.permissions,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getCheckPermissionHandler: (id, callback) => {
      dispatch(checkPermissionAction(id, callback));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(BreadcrumbForClient);
